import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import parse from "html-react-parser";
import Nav from "./components/Nav";

const BlogDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [related, setRelated] = useState([]);

  useEffect(() => {
    const fetchBlog = async () => {
      const docRef = doc(db, "blogs", id);
      const docSnap = await getDoc(docRef);
      if (docSnap.exists()) {
        setBlog(docSnap.data());
      }

      // جلب المقالات الأخرى (باستثناء الحالية)
      const querySnapshot = await getDocs(collection(db, "blogs"));
      const allBlogs = querySnapshot.docs.map((d) => ({
        id: d.id,
        ...d.data(),
      }));
      const filtered = allBlogs.filter((b) => b.id !== id).slice(0, 3);
      setRelated(filtered);
    };
    fetchBlog();
  }, [id]);

  const formatDate = (timestamp) => {
    if (!timestamp || !timestamp.seconds) return "—";
    const date = new Date(timestamp.seconds * 1000);
    return date.toLocaleDateString("ar-EG", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });
  };

  if (!blog)
    return (
      <p style={{ color: "#d4af37", textAlign: "center" }}>
        جاري تحميل المقال...
      </p>
    );

  // ✅ تجهيز وصف بسيط من نص المقال (بدون أكواد HTML)
  const plainText = blog.content.replace(/<[^>]+>/g, "").slice(0, 160);

  return (
    <>
        <title>{`${blog.title} | مكتب العلاء الدين حامد للمحاماة`}</title>
        <meta name="description" content={plainText} />
        <meta property="og:title" content={blog.title} />
        <meta property="og:description" content={plainText} />
        <meta property="og:image" content={blog.imageUrl} />
        <meta property="og:type" content="article" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={blog.title} />
        <meta name="twitter:description" content={plainText} />
        <meta name="twitter:image" content={blog.imageUrl} />

      <Nav />
      <div
        style={{
          backgroundColor: "black",
          color: "white",
          minHeight: "100vh",
          paddingTop: "150px",
        }}
      >
        <div className="container">
          <div
            style={{
              borderBottom: "1px solid #d4af37",
              paddingBottom: "20px",
              marginBottom: "30px",
              textAlign: "center",
            }}
          >
            <h1
              style={{
                fontSize: "2rem",
                background:
                  "linear-gradient(90deg,#FDC977,#BD9D63,#FFE6AD,#AE8443)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              {blog.title}
            </h1>
            <p style={{ color: "#d4af37" }}>{formatDate(blog.createdAt)}</p>
          </div>

          <img
            src={blog.imageUrl}
            alt={blog.title}
            style={{
              width: "100%",
              borderRadius: "15px",
              boxShadow: "0 0 10px #d4af37",
              marginBottom: "30px",
            }}
          />

          <div
            style={{
              lineHeight: "2",
              fontSize: "1.1rem",
              color: "#ddd",
              textAlign: "justify",
              marginBottom: "60px",
            }}
          >
            {parse(blog.content)}
          </div>

          <div>
            <h2
              style={{
                color: "#d4af37",
                borderBottom: "2px solid #d4af37",
                display: "inline-block",
                marginBottom: "20px",
              }}
            >
              مقالات ذات صلة 📚
            </h2>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                gap: "20px",
              }}
            >
              {related.map((item) => (
                <div
                  key={item.id}
                  style={{
                    backgroundColor: "#111",
                    border: "1px solid #d4af37",
                    borderRadius: "10px",
                    overflow: "hidden",
                    cursor: "pointer",
                    transition: "all 0.3s",
                  }}
                  onClick={() => navigate(`/blog/${item.id}`)}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.transform = "scale(1.03)")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.transform = "scale(1)")
                  }
                >
                  <img
                    src={item.imageUrl}
                    alt={item.title}
                    style={{
                      width: "100%",
                      height: "180px",
                      objectFit: "cover",
                    }}
                  />
                  <div style={{ padding: "10px" }}>
                    <h3
                      style={{
                        fontSize: "1rem",
                        color: "#FDC977",
                        marginBottom: "5px",
                      }}
                    >
                      {item.title.length > 50
                        ? item.title.slice(0, 50) + "..."
                        : item.title}
                    </h3>
                    <p style={{ color: "#999", fontSize: "0.9rem" }}>
                      {formatDate(item.createdAt)}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogDetails;
